<template>
    <v-dialog persistent
              @keydown.esc="closeDialog"
              v-model="$store.getters.confirmModal"
              :retain-focus="false"
              width="550" style=" min-height: 350px">
        <v-card  style="opacity: 0.9">
            <v-card-title class="primary" >
                <h3 class="white--text">Επιβεβαίωση Ενέργειας</h3>
                <v-spacer></v-spacer>
                <v-icon @click="closeDialog" color="white">close</v-icon>
            </v-card-title>

            <v-card-text style="background-color: #1f1f1f" class="justify-center  pt-12">
                <v-row>
                    <v-col>
                        <h4 class="white--text">{{mainText}}</h4>
                    </v-col>
                </v-row>
            </v-card-text>



            <v-card-actions style="background-color: #1f1f1f" class="justify-center pb-12 pt-6">
                <v-btn v-if="showConfirmActions" @click="showType" style="text-transform: none !important;" large rounded color="primary">
                    Επιβεβαίωση
                    <v-icon style="color: #82d9bf"  right dark> mdi-checkbox-marked-circle </v-icon>
                </v-btn>

                <v-btn v-if="showConfirmActions" @click="closeDialog" style="text-transform: none !important;" large rounded color="primary">
                    Άκυρο
                    <v-icon style="color: #82d9bf"  right dark> mdi-close-circle </v-icon>
                </v-btn>
                <span  v-if="!showConfirmActions" class="pr-6" style="text-transform: none !important;color: #82d9bf"> Τύπος Αρχείου</span>
                <v-btn v-if="!showConfirmActions" @click="confirm('PDF')"  class="pr-2" style="text-transform: none !important; background-color: #82d9bf; color: #1f1f1f"  rounded>
                    PDF

                </v-btn>

                <v-btn v-if="!showConfirmActions" @click="confirm('E-PUB')" style="text-transform: none !important; background-color: #82d9bf; color: #1f1f1f"  rounded>
                    E-PUB

                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>

    import {eventBus} from "../main";
    export default {
        name: "ConfirmationDialog",
        data: () => ({
            showConfirmActions: true,
        }),
        props: {
            eventName: String,
            mainText: String
        },

        methods: {

            closeDialog() {
                this.showConfirmActions = true;
                this.$store.commit('setConfirmModal', false)
            },

            showType(){
                this.showConfirmActions = !this.showConfirmActions;
            },

            confirm(type){

                this.$store.commit('setConfirmModal', false);
                eventBus.$emit(this.eventName, type);
            }
        }
    }
</script>

<style scoped>

</style>